export const OPTION_MENU = {
  LOGIN: 'LOGIN',
  JOIN_AS_VENUE: 'JOINASVENUE',
  JOIN_AS_VENDOR: 'JOINASVENDOR',
  ABOUT_US: 'ABOUTUS',
  HELP: 'HELP',
  LOGOUT: 'LOGOUT',
  HOME: 'HOME',
};
export const MENU_USER = [
  {
    display_name: 'Forgot',
    route: '',
    roles: [],
  },
];
